import script from "./BookingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPage.vue?vue&type=script&setup=true&lang=js"

import "./BookingPage.vue?vue&type=style&index=0&id=23f1c130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f1c130"]])

export default __exports__